// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2247":"167fea3a","3593":"0084bd85","3735":"6cfd03b7","4365":"3ca18596","6605":"26f209df","8793":"8092f78e","9539":"3d1baf44","9751":"ea557160"}[chunkId] + ".chunk.css";
};